export default window.uiThemesModule;